<template>
  <section 
    :class="{
      '--large': mobileBreakPoint == 'lg', 
      '--medium': mobileBreakPoint == 'md'
    }" 
    class="gf-search-project-filters">
    <div class="gf-search-project-filters__content">
      <!-- список со скроллом на пк -->
      <gf-search-filter-project-language />
    </div>
    <div class="gf-search-project-filters__mobile-content">
      <gf-overlay-filter
        :is-opened="isOpenedModel"
        submit-button-text="Показать результаты"
        @close="closeFilterOverlay"
      >
        <template #filters>
          <!-- карточка в overlay мобильной версии -->
          <div>
            <gf-search-filter-project-language
              @showMore="openSubFiltersOverlay('languages')"
              :mobile-break-point="mobileBreakPoint"  
              :show-short-list="true"
            />
          </div>
        </template>
        <template #filtersOverlay>
          <gf-overlay-filter
            :header-text="activeSubFilterName ? $t(`message.${activeSubFilterName}`) : null"
            :is-opened="isSubFilterOpened"
            :can-return="true"
            @close="closeFilterOverlay"
            @return="closeSubFiltersOverlay"
            submit-button-text="Готово"
          >
            <template #filters>
              <!-- мобильный оверлей полный список-->
              <div>
                <gf-search-filter-project-language
                  :mobile-break-point="mobileBreakPoint"  
                  :show-header="false"
                />
              </div>
            </template>
          </gf-overlay-filter>
        </template>
      </gf-overlay-filter>
    </div>
  </section>
</template>

<script>
import GfSearchFilterProjectLanguage from '@shared/modules/search/components/filters/project/GfSearchFilterProjectLanguage';
import GfOverlayFilter from '@/shared-modules/shared-components/shared/filter/GfOverlayFilter';

export default {
  name: 'GfSearchProjectFilters',
  components: {
    GfSearchFilterProjectLanguage,
    GfOverlayFilter
  },
  props: {
    isOpened: {
      type: Boolean,
      default: false
    },
    mobileBreakPoint: {
      type: String, 
      // props принимает брейк-поинт lg, md. 
      // Можно также дописать под все брейк-поинт в файле theme.scss
      default: 'md'
    }
  },
  data() {
    return {
      isOpenedModel: false,
      isOpenedSubFiltersModel: {
        languages: false
      },
      activeSubFilterName: null
    };
  },
  computed: {
    isSubFilterOpened() {
      return (
        Object.keys(this.isOpenedSubFiltersModel).find(
          (elementKey) => this.isOpenedSubFiltersModel[elementKey] === true
        )?.length > 0
      );
    },
  },
  watch: {
    isOpened() {
      this.isOpenedModel = this.isOpened;
    }
  },
  mounted() {
    this.isOpenedModel = this.isOpened;
  },
  methods: {
    closeFilterOverlay() {
      this.$emit('close');
      this.isOpenedModel = false;
      this.closeSubFiltersOverlay();
    },
    openSubFiltersOverlay(filterName) {
      this.activeSubFilterName = filterName;
      this.isOpenedSubFiltersModel[filterName] = true;
    },
    closeSubFiltersOverlay() {
      this.isOpenedSubFiltersModel[this.activeSubFilterName] = false;
      this.activeSubFilterName = null;
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-search-project-filters';


#{$this} {
  &.--medium {
    @include theme.md {
      margin-top: 14px;
    }

    #{$this}__content {
      display: none;

      @include theme.md {
        display: flex;
      }
    }

    #{$this}__mobile-content {
      display: flex;

      @include theme.md {
        display: none;
      }
    }
  }

  &.--large {
    @include theme.lg {
      margin-top: 14px;
    }

    #{$this}__content {
      display: none;

      @include theme.lg {
        display: flex;
      }
    }

    #{$this}__mobile-content {
      display: flex;

      @include theme.lg {
        display: none;
      }
    }
  }
}
</style>
